import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:".notification-bar"},[_c(VAlert,{attrs:{"type":_vm.notificationTypeClass}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }